import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { constructUrl } from './VimeoPlayer.utils';
import { classNames } from '../../../../../../utils/classname';
import Embed from '../../../../../foundation/components/Embed';
import { IN_VIEWPORT_LOAD_STRATEGY } from '../../../../../foundation/components/Embed/Embed.constants';
import { EmbedAspectRatioPropType, EmbedLoadStrategyPropType } from '../../../../../foundation/components/Embed/Embed.types';
var defaultProps = {
  videoId: '',
  aspectRatio: null,
  autoplay: true,
  controls: false,
  loop: true,
  mute: true,
  className: '',
  loadStrategy: IN_VIEWPORT_LOAD_STRATEGY,
  placeholder: '',
  icon: ''
};
export default function VimeoPlayer(_ref) {
  var videoId = _ref.videoId,
    aspectRatio = _ref.aspectRatio,
    autoplay = _ref.autoplay,
    controls = _ref.controls,
    loop = _ref.loop,
    mute = _ref.mute,
    className = _ref.className,
    loadStrategy = _ref.loadStrategy,
    placeholder = _ref.placeholder,
    icon = _ref.icon;
  var embedUrl = constructUrl({
    videoId: videoId,
    controls: controls,
    mute: mute,
    loop: loop,
    autoplay: autoplay
  });
  var finalClassName = classNames(_defineProperty({
    video: true,
    vimeo: true
  }, className, true));
  return /*#__PURE__*/React.createElement(Embed, {
    url: embedUrl,
    className: finalClassName,
    aspectRatio: aspectRatio,
    loadStrategy: loadStrategy,
    placeholder: placeholder,
    icon: icon
  });
}
VimeoPlayer.defaultProps = defaultProps;